/**
 * Created by 高春超 on 2018/1/23.
 */
import {
  login,
  loginOut,
  getSigned,
  getUserInfo,
  getDrawTimes,
  loginNew,
  getUserInfoNew,
  getMemberLevel,
} from "api/user";
import { setSession, getSession, clearSession } from "utils/tool";
const user = {
  state: {
    sid: "",
    token: "",
    uuid: "",
    memberId: "",
    face: "",
    lvname: "",
    signed: "",
    name: "",
    market: false,
    storeId: "",
    lucky: 0,
    isFirstBuy: "",
  },

  mutations: {
    SET_SID: (state, sid) => {
      state.sid = sid;
    },
    TOKEN: (state, token) => {
      state.token = token;
    },
    SET_UUID: (state, uuid) => {
      state.uuid = uuid;
    },
    SET_MEMID: (state, memberId) => {
      state.memberId = memberId;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_SIGNED: (state, signed) => {
      state.signed = signed;
    },
    SET_LUCKY: (state, lucky) => {
      state.lucky = lucky;
    },
    SET_Face: (state, face) => {
      state.face = face;
    },
    SET_LEVEL: (state, lvname) => {
      state.lvname = lvname;
    },
    SET_MARKET: (state, market) => {
      state.market = market;
    },
    SET_STOREID: (state, storeId) => {
      state.storeId = storeId;
    },
    SET_USER: (state, info) => {
      state.info = info;
    },
    SET_ISFIRSTBUY: (state, isFirstBuyArea) => {
      state.isFirstBuy = isFirstBuyArea;
    },
  },

  actions: {
    initSID({ commit }) {
      commit("SET_SID", getSession("sid"));
    },
    initUUID({ commit }) {
      commit("SET_UUID", getSession("uuid"));
    },
    initName({ commit }) {
      commit("SET_NAME", getSession("name"));
    },
    initSigned({ commit }) {
      commit("SET_SIGNED", getSession("signed"));
    },
    initMemId({ commit }) {
      commit("SET_MEMID", getSession("memberId"));
    },
    initStoreId({ commit }) {
      commit("SET_STOREID", getSession("storeId"));
    },
    initLucky({ commit }) {
      commit("SET_LUCKY", getSession("lucky"));
    },
    initMaket({ commit }) {
      commit(
        "SET_MARKET",
        getSession("market") === "" ? false : getSession("market")
      );
    },
    initFace({ commit }) {
      commit("SET_Face", getSession("face"));
    },
    initLevel({ commit }) {
      commit("SET_LEVEL", getSession("lvname"));
    },
    initIsFirstBuy({ commit }) {
      commit("SET_ISFIRSTBUY", getSession("isFirstBuy"));
    },
    loginSystem({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        // 2021-09-03 修改token取值
        loginNew(userInfo)
          .then((response) => {
            if (response.resCode == 1) {
              const data = response.data;
              commit("SET_SID", data.sid);
              setSession("sid", data.sid);
              setSession("userName", data.loginName);
              // 获取用户等级
              getMemberLevel({ loginName: data.loginName }).then((res) => {
                setSession("membershipLevelName", res.data.membershipLevelName);
                setSession("isFirstBuy", res.data.businessCenterType && res.data.businessCenterType > 0 ? 1 : 0);
                commit("SET_ISFIRSTBUY", res.data.businessCenterType && res.data.businessCenterType > 0 ? 1 : 0);
              });

              // 获取用户个人信息
              getUserInfo().then((res) => {
                console.log(res, "用户信息--------------------");
                commit("SET_NAME", res.data.memberRongcloudPO.userId || res.data.nickname);
                setSession("name", res.data.memberRongcloudPO.name || res.data.memberRongcloudPO.userId);
                commit("SET_MEMID", res.data.memberId);
                setSession("memberId", res.data.memberId);
                const lvname =
                  res.data.memberLevelName === null
                    ? "普通会员"
                    : res.data.memberLevelName;
                commit("SET_LEVEL", lvname);
                setSession("lvname", lvname);
                commit("SET_Face", res.data.face);
                setSession("face", res.data.face);
                commit("SET_MARKET", res.data.showBatchMarket);
                setSession("market", res.data.showBatchMarket);
                commit("SET_STOREID", res.data.storeId);
                setSession("storeId", res.data.storeId);
                // 存储用户手机号
                setSession("phone", res.data.telephone);
                commit("TOKEN", res.data.token);
                setSession("token", res.data.token);

              });
              getUserInfoNew(userInfo).then((res) => {
                let data = res.data;
                commit("SET_UUID", data.uuid);
                setSession("uuid", data.uuid);
              });
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取签到信息
    getSigned({ commit }) {
      return new Promise((resolve, reject) => {
        getSigned()
          .then((response) => {
            const data = response.data;
            commit("SET_SIGNED", data.signFlag);
            setSession("signed", data.signFlag);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取抽奖信息
    // getLucky({commit}){
    //   return new Promise((resolve, reject) => {
    //     getDrawTimes({ 'luckydip_type': 3}).then(response => {
    //       if(response.result != 0){
    //         const data = response.data;
    //         if(data){
    //           commit('SET_LUCKY', data.times);
    //           setSession('lucky', data.times);
    //         }
    //       }
    //       resolve();
    //     }).catch(error => {
    //       reject(error);
    //     });
    //   });
    // },
    // 登出
    LogOut({ commit, data }) {
      return new Promise((resolve, reject) => {
        loginOut(data)
          .then(() => {
            commit("SET_SID", "");
            commit("SET_NAME", "");
            clearSession();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/components/store/modules/user.js